// import React from 'react';
import axios from 'axios';
import { parseString } from 'xml2js';

import {
	SET_UPLOAD_URLS,
	GET_CHUNK,
	SET_CHUNK,
	ENABLE_RECORDING,
	MARK_ITEM_WITH_AUDIO,
	SET_WORDS_RECOGNISED,
	SET_WORDS_PER_MINUTE,
} from './types';
import { showFeedback, setItemMarkedText } from './index';

const API_URL = window.NL_CONFIG.api.url;
const MAX_FAILURES = 10;

let apiRequestConfig = {
	withCredentials: true
};

if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
	// development
	const auth = require('../config/auth.js').default; // eslint-disable-line global-require
	apiRequestConfig.auth = auth;
} else {
	// production
	apiRequestConfig = {
		headers: {
			'X-Session-Cookie-Name': window.discovia && window.discovia.directory
		},
	};
}

export const analyzeAudio = (data) => async (dispatch, getState) => {
	/*
	dispatch({ type: SET_WORDS_PER_MINUTE, payload: 100 });
	dispatch({ type: SET_WORDS_RECOGNISED,
		payload: {
			wordsRecognisedPercent: 85,
			wordsRecognised: 50,
			totalWords: 1000
		}
	});
	dispatch(showFeedback('recordingSuccessful'));
	*/
	try {
		dispatch(showFeedback('analysis', true));

		const { loader: { interaction, testMode } } = getState();

		parseString((window.OVERRIDE_XML ? window.OVERRIDE_XML : data), (err, result) => {
			if (!result) {
				const message = 'No response was returned from the audio analysis service.\n' +
				'Please contact support with this error message.\n' +
				'=======================================';
				throw new Error(message);
			}

			if (err) console.log('err', err);
			if (err) {
				const message = 'An error was returned from the audio analysis service.\n' +
				'Please contact support with this error message.\n' +
				'=======================================\n' +
				`${err}\n` +
				'=======================================';
				throw new Error(message);
			}

			if (window.NL_CONFIG.sound.enabled) {
				window.soundManager.play('result');
			}

			let nRef;
			let nCorr;
			let wpm;

			console.log(result);

			try {
				[{ nRef, nCorr }] = result.message.AAResult[0].analysis[0].readingSummary;
				[{ wpm }] = result.message.AAResult[0].analysis[1].speakingSummary;
			} catch (e) {
				dispatch(showFeedback('quality', null, 256));
				return;
			}

			const audioQualityMsgId = window.loader.exercises.common.audioanalysis.getAudioQualityMsgId(result.message.AAResult[0].audioQuality[0].$.status);

			if (audioQualityMsgId) {
				dispatch(showFeedback('quality', null, audioQualityMsgId));
				return;
			}

			if (err) alert(err.message);

			if (result.message.referenceID) {
				console.log(`Processed audio URL: https://ssrest.carnegiespeech.com/getspeech.php?file=${result.message.referenceID[0].$.value}`);
			}

			if (result.message.AAResult[0].error) {
				const errors = result.message.AAResult[0].error.join('\n - ');
				alert(`DESIGN-TIME ERROR\n\nThe following errors were returned by the analysis API:\n - ${errors}`);
			}

			const targetText = result.message.AAResult[0].analysis[0].readingSummary[0].targetText[0];
			const targetTokens = targetText.split(/(a\.m\.|p\.m\.|y\.|[0-9][,0-9]*[0-9]|[-a-z0-9']+)/gi);
			console.log('targetTokens', targetTokens);

			let markedText = '';
			let lastType = '';
			let numberCorrect = 0;
			let numberWords = 0;
			let tokenCount = 0;
			let atts;
			let tooltipText;
			console.log(result.message.AAResult[0].analysis[0].alignmentDetails[0].alignEntry);
			result.message.AAResult[0].analysis[0].alignmentDetails[0].alignEntry.forEach((entry, alignCount) => {
				let word;
				switch (entry.$.alignType) {
					case 'OK':
						word = entry.target[0]._;
						// console.log(entry.$.alignType, entry, word);
						while (targetTokens[tokenCount] !== word && tokenCount < targetTokens.length) {
							markedText += targetTokens[tokenCount];
							tokenCount++;
						}
						tokenCount++;

						atts = entry.wordSeg[0].word[0].$;
						tooltipText = '';
						switch (atts.ppStatus) {
							case 'ok': tooltipText = 'Word pronounced well'; break;
							case 'soso': tooltipText = 'Word pronounced okay'; break;
							default: tooltipText = 'Word incorrectly pronounced'; break;
						}
						word = `<span title="${tooltipText}" data-${atts.ppStatus}>${word}</span>`;
						if (atts.ppStatus !== 'bad') numberCorrect++;
						numberWords++;
						break;
					case 'SUB':
						word = entry.target[0]._;
						if (!entry.target[0]._) {
							// If the tag has no attributes then the word is in the target (e.g. for unknown words, this shouldn't happen usually)
							[word] = entry.target;
						}
						console.log(entry.$.alignType, entry, word);
						while (targetTokens[tokenCount] !== word && tokenCount < targetTokens.length) {
							markedText += targetTokens[tokenCount];
							tokenCount++;
						}
						tokenCount++;
						if (entry.target[0]._) {
							word = `<span data-bad title="Word not recognised">${entry.target[0]._}</span>`;
							numberWords++;
						}
						break;
					case 'DEL':
						word = entry.target[0]._;
						if (!entry.target[0]._) {
							// If the tag has no attributes then the word is in the target (e.g. for unknown words, this shouldn't happen usually)
							[word] = entry.target;
						}
						console.log(entry.$.alignType, entry, word);
						while (targetTokens[tokenCount] !== word && tokenCount < targetTokens.length) {
							markedText += targetTokens[tokenCount];
							tokenCount++;
						}
						tokenCount++;
						if (entry.target[0]._) {
							word = `<span data-bad title="Word not detected">${word}</span>`;
							numberWords++;
						}
						break;
					case 'INS':
						// if (lastType === 'SUB') return;
						if (lastType === entry.$.alignType) return;
						word = ' <span data-unknown title="Unknown sound heard here"><i class="fas fa-question-circle"></i></span> ';
						// word = ' <span data-unknown title="Unknown sound heard here"><i class="fas fa-ellipsis-h"></i></span> ';
						break;
					case 'pause':
						// markedText += ' ... ';
						return;
					default:
						alert(`Unknown entry type: ${entry.$.alignType}`);
				}
				markedText += word;
				lastType = entry.$.alignType;
			});
			// Add on the tokens at the end of the sentence.
			while (tokenCount < targetTokens.length) {
				console.log('remaining tokens', targetTokens[tokenCount]);
				markedText += targetTokens[tokenCount];
				tokenCount++;
			}
			dispatch(setItemMarkedText(markedText));

			dispatch({ type: SET_WORDS_PER_MINUTE, payload: Math.round(wpm) });
			dispatch({
				type: SET_WORDS_RECOGNISED,
				payload: {
					wordsRecognisedPercent: Math.round(numberCorrect / numberWords * 100),
					wordsRecognised: numberCorrect,
					totalWords: numberWords
				}
			});
			console.log(`NL score ${numberCorrect} out of ${numberWords}: ${Math.round(numberCorrect / numberWords * 100)}%`);
			console.log(`Carnegie score ${nCorr[0]} out of ${nRef[0]}: ${Math.round(Number(nCorr[0]) / Number(nRef[0]) * 100)}%`);
			// dispatch({
			// 	type: SET_WORDS_RECOGNISED,
			// 	payload: {
			// 		wordsRecognisedPercent: Math.round(Number(nCorr[0]) / Number(nRef[0]) * 100),
			// 		wordsRecognised: Number(nCorr[0]),
			// 		totalWords: Number(nRef[0])
			// 	}
			// });
			dispatch(showFeedback('recordingSuccessful'));
			if (interaction && !testMode) {
				interaction.setScore(numberCorrect, numberWords);
			}
		});
	} catch (e) {
		alert(e);
		console.log(e);
		dispatch(showFeedback('errored', null, (e.response && e.response.status) ? e.response.status : null));
	}
	dispatch({ type: ENABLE_RECORDING });
};

export const saveAudio = (blob) => async (dispatch, getState) => {
	const { exercise: { s3SignedUrl, currentItem }, loader: { interaction } } = getState();
	if (
		!(window.userSession && window.userSession.user && window.userSession.user.readonly) &&
		interaction &&
		!window.NL_CONFIG.isSample &&
		!window.concurrentUser
	) {
		try {
			await axios({
				method: 'put',
				url: s3SignedUrl,
				data: blob,
				config: { headers: { 'Content-Type': blob.type } }
			});
		} catch (err) {
			console.log('s3SignedUrl axios error:', err);
		}
		dispatch({ type: MARK_ITEM_WITH_AUDIO, payload: currentItem });
	}
};

export const getUploadUrls = () => async (dispatch, getState) => {
	// console.log('actions:getUploadUrls()');
	try {
		const { exercise: { itemsAAXML, currentItem }, loader: { itemsKeys } } = getState();
		const data = { aaxml: itemsAAXML[currentItem], key: itemsKeys[currentItem] };
		const apiUrl = `${API_URL}/audioanalysis/${(window.NL_CONFIG && window.NL_CONFIG.isSample) ? 'sample-url' : 'url'}`;

		let success = false;
		let attempts = 0;
		let remoteURL;
		let s3SignedURL;
		while (!success) {
			try {
				attempts++;
				({ data: { remoteURL, s3SignedURL } } = await axios.post(apiUrl, data, apiRequestConfig));
				success = true;
			} catch (err) {
				if (attempts >= MAX_FAILURES) throw err;
			}
		}
		// console.log('remoteURL', remoteURL);
		dispatch({ type: SET_UPLOAD_URLS,
			payload: {
				remoteUrl: remoteURL,
				s3SignedUrl: s3SignedURL
			}
		});
	} catch (e) {
		alert(e);
		console.log(e);
		dispatch(showFeedback('errored', null, (e.response && e.response.status) ? e.response.status : null));
		dispatch({ type: ENABLE_RECORDING });
	}
};

export const requestChunk = (aaPlayer) => (dispatch) => {
	// console.log('actions:requestChunk()');
	// console.log('aaPlayer', aaPlayer);
	dispatch({ type: GET_CHUNK });

	setTimeout(() => {
		aaPlayer.requestNextChunk();
	}, 500);
	// aaPlayer.requestNextChunk();
};

export const chunkReady = (data) => async (dispatch, getState) => {
	// console.log('actions:chunkReady()');
	// console.log('data', data);
	const { exercise: { remoteUrl, chunks, recording } } = getState();
	const url = remoteUrl;
	// console.log('url', url);

	const formData = new FormData();
	// console.log('chunk', data.chunk);
	formData.append('audio', data.chunk);
	formData.append('partial', chunks.length + 1);
	formData.append('userId', window.discovia && window.discovia.user ? window.discovia.user.id : null);
	if (!recording) {
		// No longer recording so send final request
		formData.append('finalsize', data.totalBytes);
		formData.append('samplerate', data.sampleRate);
	}

	let attempts = 0;
	let success = false;
	let aaRes;

	try {
		while (!success) {
			try {
				attempts++;
				if (attempts === 5) formData.append('letItGo', 'true');
				aaRes = await axios({
					method: 'post',
					url,
					data: formData,
					config: {
						headers: { 'Content-Type': 'multipart/form-data' },
						withCredentials: true
					}
				});
				success = true;
			} catch (err) {
				console.log(err);
				// console.log(`Error uploading (${attempts} attempt(s))`);
				if (attempts >= MAX_FAILURES) throw err;
			}
		}
	} catch (e) {
		alert(e);
		console.log(e);
		dispatch(showFeedback('errored', null, (e.response && e.response.status) ? e.response.status : null));
		dispatch({ type: ENABLE_RECORDING });
		return;
	}

	dispatch({
		type: SET_CHUNK,
		payload: {
			buffer: data.chunk,
			lastChunk: !recording
		}
	});

	if (!recording) {
		dispatch(analyzeAudio(aaRes.data));
	}
};

